// material-ui

// third party
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

// project imports

// ============================|| LOGIN ||============================ //

const Login = () => {
  return (
    <>
      <Authenticator loginMechanisms={['email']} hideSignUp={true}></Authenticator>
    </>
  );
};

export default Login;
